import React, { useEffect, useState } from 'react';
import { Card, Input, Button, Avatar, List, message, Popconfirm, Modal, Empty, Skeleton } from 'antd';
import { NotificationOutlined, DeleteOutlined, FlagOutlined } from '@ant-design/icons';
import api from '../../services/api';
import { absoluteUploadUrl } from '../../utils/uploadUrl';

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';

function timeAgo(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return 'agora';
  if (s < 3600) return `${Math.floor(s / 60)}min`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return d.toLocaleDateString('pt-BR');
}

// Painel de noticias do time. Se isOwner=true, mostra composer no topo.
// Sempre mostra lista com denuncia + delete pra dono/autor.
export default function TeamNewsPanel({ teamId, isOwner = false, currentPlayerId = null }) {
  const [news, setNews] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [posting, setPosting] = useState(false);

  const load = () => {
    setLoading(true);
    api.get(`/community/teams/${teamId}/news`)
      .then(r => setNews(r.data?.news || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  useEffect(() => { if (teamId) load(); }, [teamId]);

  const publish = async () => {
    const t = text.trim();
    if (t.length < 3) { message.warning('Escreve algo antes'); return; }
    setPosting(true);
    try {
      await api.post(`/community/teams/${teamId}/news`, { text: t });
      setText('');
      message.success('Publicado');
      load();
    } catch (err) {
      message.error(err?.response?.data?.message || 'Erro');
    } finally { setPosting(false); }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/community/news/${id}`);
      setNews(prev => prev.filter(n => n.id !== id));
      message.success('Removida');
    } catch { message.error('Erro'); }
  };

  const report = (n) => {
    Modal.confirm({
      title: 'Denunciar essa publicação?',
      content: `Publicações denunciadas por várias pessoas são escondidas automaticamente.`,
      okText: 'Denunciar', cancelText: 'Voltar', okType: 'danger',
      onOk: async () => {
        try {
          await api.post(`/community/news/${n.id}/report`);
          message.success('Denúncia enviada, valeu');
        } catch { message.error('Erro'); }
      },
    });
  };

  return (
    <Card style={{ borderRadius: 16, marginBottom: 16 }}
      title={<><NotificationOutlined /> Notícias do time</>}>
      {isOwner && (
        <div style={{ marginBottom: 16 }}>
          <Input.TextArea
            value={text} onChange={e => setText(e.target.value)}
            placeholder="Fala pros teus jogadores... jogo confirmado, convocação especial, aviso importante"
            rows={3} maxLength={2000} showCount
          />
          {/* margin-top maior pra ficar folgado do contador do showCount */}
          <div style={{ marginTop: 28, textAlign: 'right' }}>
            <Button type="primary" onClick={publish} loading={posting}
              style={{ background: BRAND, borderColor: BRAND }}>
              Publicar
            </Button>
          </div>
        </div>
      )}
      {loading ? <Skeleton active /> :
        news.length === 0 ? <Empty description={isOwner ? 'Nenhuma publicação. Faz a primeira!' : 'Sem publicações ainda'} /> :
        <List
          dataSource={news}
          renderItem={(n) => {
            const isMine = currentPlayerId && n.author_cp_id === currentPlayerId;
            const canDelete = isOwner || isMine;
            return (
              <List.Item style={{ alignItems: 'flex-start' }}
                actions={canDelete ? [
                  <Popconfirm title="Remover?" onConfirm={() => remove(n.id)} key="del">
                    <Button size="small" type="text" danger icon={<DeleteOutlined />} />
                  </Popconfirm>,
                ] : [
                  <Button size="small" type="text" icon={<FlagOutlined />} key="report"
                    onClick={() => report(n)} />,
                ]}>
                <List.Item.Meta
                  avatar={<Avatar src={absoluteUploadUrl(n.author_photo)} />}
                  title={<><b>{n.author_name}</b> <span style={{ color: '#8c8c8c', fontSize: 12, fontWeight: 400 }}>· {timeAgo(n.created_at)}</span></>}
                  description={<div style={{ color: '#333', whiteSpace: 'pre-wrap', fontSize: 14 }}>{n.text}</div>}
                />
              </List.Item>
            );
          }}
        />
      }
    </Card>
  );
}
